import { auth, db } from '../firebase/config';
import { collection, getDocs, query, where } from 'firebase/firestore';

// Claim records store the adjuster's name, while the profile stores the email.
// Match both company and name so same-name adjusters at other firms are never invited.
export const getAssignedAdjusterEmail = async ({ companyName, adjusterName }) => {
  if (!companyName || !adjusterName) return '';
  const snapshot = await getDocs(query(collection(db, 'adjusters'), where('company', '==', companyName)));
  const matches = snapshot.docs.map(doc => doc.data())
    .filter(adjuster => adjuster.active !== false && adjuster.name === adjusterName && adjuster.email);
  return matches.length === 1 ? matches[0].email.trim().toLowerCase() : '';
};

export const syncZohoCalendarEvent = async (payload) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Sesión de administrador requerida.');
  const token = await user.getIdToken();
  const response = await fetch('/api/zoho-calendar.php', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'Zoho Calendar no respondió.');
  return result;
};

// Trae TODOS los eventos del mes desde el calendario Zoho de Adjustify —
// incluidos los creados directo en Zoho, fuera de la app (pedido
// 2026-09-19: "que se vea aquí todo, inclusive las que no hemos creado
// nosotros"). El filtrado de quién ve qué lo hace el propio backend
// (zoho-calendar.php, action=list) según el token de quien pregunta — acá
// no hay nada que filtrar de más.
export const listZohoCalendarEvents = async (month) => {
  const user = auth.currentUser;
  if (!user) throw new Error('Debes iniciar sesión.');
  const token = await user.getIdToken();
  const response = await fetch('/api/zoho-calendar.php', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'list', company: 'Adjustify Claims', month })
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || 'Zoho Calendar no respondió.');
  return result.events || [];
};
